import type { FC } from 'react';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Dialog, DialogContent, PrimaryButton } from '@crehana/ui';

import useHeaderTranslation from '../../hooks/useHeaderTranslation';

export interface ConfirmationDialogProps {
  open: boolean;
  onDismiss: () => void;
}

const ConfirmationDialog: FC<
  React.PropsWithChildren<ConfirmationDialogProps>
> = ({ open, onDismiss }) => {
  const { t } = useHeaderTranslation();

  return (
    <Dialog open={open} onDismiss={onDismiss}>
      <DialogContent
        type="s"
        className="flex flex-col justify-center items-center"
      >
        <h3 className="font-h3 text-center mb-16 whitespace-pre-line">
          {t('HEADER_CONFIRMATION_DIALOG_TITLE')}
        </h3>
        <p className="font-body3 mb-24 text-center whitespace-pre-line">
          {t('HEADER_CONFIRMATION_DIALOG_DESCRIPTION')}
        </p>
        <PrimaryButton
          label={t('HEADER_CONFIRMATION_DIALOG_BUTTON')}
          onClick={onDismiss}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
